import Swiper from 'swiper/core';
import { Navigation, Autoplay, Pagination, EffectFade } from 'swiper/modules';
import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    document.querySelectorAll('.js--hover--play--video').forEach(function(element) {
        element.addEventListener('mouseenter', function() {
            var id = 'video__' + this.getAttribute('data-id'),
                vid = document.getElementById(id);
            if (vid) {
                vid.play();
            }
        });
        
        element.addEventListener('mouseleave', function() {
            var id = 'video__' + this.getAttribute('data-id'),
                vid = document.getElementById(id);
            if (vid) {
                vid.pause();
            }
        });
    });
});

loaded(() => {
    const sliders = Array.from(document.querySelectorAll('.slider--js__hero'));
    if (!sliders) {
        return;
    }

    if (!sliders?.length) {
        return;
    }

    sliders.forEach((element) => {
        const speed = element.dataset.autoplaySpeed;

        new Swiper(element, {
            slidesPerView: "auto",
            effect: "fade",
            allowTouchMove: true,
            freeMode: false,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: speed ? parseInt(speed) : 4500,
                disableOnInteraction: false,
            },
            modules: [Navigation, Autoplay, Pagination, EffectFade],
        });

        element.style.opacity = '1';
    });
});

loaded(() => {
    window.dispatchEvent(new Event('resize'));
});
